/**
 * Formats a course duration for display without modifying user-entered values.
 * @param {string | number | null | undefined} duracion
 * @returns {string}
 */
export function formatCourseDurationLabel(duracion) {
  const trimmed = String(duracion ?? "").trim();
  if (trimmed === "") {
    return "";
  }
  return trimmed;
}

/**
 * Normalizes duration before persisting: trims whitespace and never appends units automatically.
 * @param {string | number | null | undefined} duracion
 * @returns {string}
 */
export function normalizeCourseDurationInput(duracion) {
  return String(duracion ?? "").trim();
}
